import { api } from './client';

export interface GameConfigField {
  key: string;
  label: string;
  type: 'number' | 'string' | 'boolean' | 'enum' | 'steamid-list';
  min?: number;
  max?: number;
  options?: string[];
  description?: string;
  requiresRestart: boolean;
  important: boolean;
}

export interface GameConfigResponse {
  supports_config: boolean;
  schema: GameConfigField[];
  values: Record<string, unknown>;
}

export interface SaveEntry {
  name: string;
  size_bytes: number | null;
  modified_at: string;
}

export const fetchGameConfig = (id: string): Promise<GameConfigResponse> =>
  api.get<GameConfigResponse>(`/games/${id}/config`).then((r) => r.data);

export const fetchGameSaves = (id: string): Promise<{ saves: SaveEntry[] }> =>
  api.get<{ saves: SaveEntry[] }>(`/games/${id}/saves`).then((r) => r.data);

export const putGameConfig = (
  id: string,
  values: Record<string, unknown>,
  restart: boolean,
): Promise<{ ok: boolean; changed_keys: string[]; restarted: boolean }> =>
  api
    .put<{ ok: boolean; changed_keys: string[]; restarted: boolean }>(`/games/${id}/config`, {
      values,
      restart,
    })
    .then((r) => r.data);
